import * as THREE from 'three';

/**
 * Create a glass pane as a thin box geometry.
 * Positioned at the center of the clear opening.
 */
export function createGlassPane(
  width: number,
  height: number,
  thickness: number,
  material: THREE.Material,
): THREE.Mesh {
  const geo = new THREE.BoxGeometry(width, height, thickness);
  const mesh = new THREE.Mesh(geo, material);
  mesh.name = 'glass';
  mesh.castShadow = false;
  mesh.receiveShadow = false;
  return mesh;
}
